import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import Input from '@mui/material/TextField';
const City = ({setCity, city, handleSubmit}) => {
  return (
    <div className="textInput" 
            onSubmit={handleSubmit}>
            <Input
            className='city'
            placeholder='City'  
            name='city' 
            type="text" 
            onChange={(event)=>setCity(event.target.value)} 
            value={city}
            InputProps={{
        }} variant="standard"></Input>
        <button className="submit" onClick={handleSubmit} type="submit"><FontAwesomeIcon icon={faArrowRight} /></button>    
        </div>
  )
}

export default City